'use client'

import { useEffect, useRef, useState } from 'react'

import { useKeywordQuery } from '@/features/room-search'
import { useDebounce } from '@/shared/lib'

import { MIN_KEYWORD_LENGTH } from './tab'

export const useKeywordAutocomplete = (keyword: string) => {
  const debouncedKeyword = useDebounce(keyword, 200)
  const isQueryEnabled =
    keyword.length >= MIN_KEYWORD_LENGTH &&
    debouncedKeyword.length >= MIN_KEYWORD_LENGTH

  const {
    loading,
    isFetching,
    regions,
    subways,
    landmarks,
    hasNoMarker,
    hasRegions,
    hasSubways,
    hasLandmarks,
  } = useKeywordQuery({ keyword: debouncedKeyword, enabled: isQueryEnabled })

  const prevIsQueryEnabledRef = useRef(isQueryEnabled)
  const isFetchingRef = useRef(isFetching)

  isFetchingRef.current = isFetching

  const [isReturningFromEmpty, setIsReturningFromEmpty] = useState(false)

  useEffect(() => {
    if (!prevIsQueryEnabledRef.current && isQueryEnabled) {
      setIsReturningFromEmpty(isFetchingRef.current)
    }
    prevIsQueryEnabledRef.current = isQueryEnabled
  }, [isQueryEnabled])

  useEffect(() => {
    if (isReturningFromEmpty && !isFetching) {
      setIsReturningFromEmpty(false)
    }
  }, [isFetching, isReturningFromEmpty])

  return {
    // 키워드 삭제 후 재입력 시 stale 결과가 보이는 것을 방지하기 위해 fetch 완료까지 로딩 유지
    loading: loading || isReturningFromEmpty,
    regions,
    subways,
    landmarks,
    hasNoMarker,
    hasRegions,
    hasSubways,
    hasLandmarks,
  }
}
